import { statusMeta, type FeedStatus } from "@/mocks/news";

const order: FeedStatus[] = ["突发", "追踪中", "已澄清", "已完结"];

export default function StatusLegend() {
  return (
    <section aria-label="信息状态说明" className="rounded-lg border border-background-200 bg-background-100/70 p-5 md:p-6">
      <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
        <i className="ri-bookmark-3-line text-secondary-600"></i>
        状态怎么看
      </h2>
      <ul className="mt-4 space-y-3">
        {order.map((status) => (
          <li key={status} className="flex items-start gap-3">
            <span className={`mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full ${statusMeta[status].dot}`}></span>
            <span>
              <span className="text-sm font-medium text-foreground-900">{status}</span>
              <span className="mt-0.5 block text-xs leading-relaxed text-foreground-600">{statusMeta[status].desc}</span>
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}